<template>
  <div>
    <div class="form-group row">
      <div class="col-md-8">
        <el-input type="search" name="search" placeholder="Search Tags" clearable v-model="searchQuery" />
      </div>
      <div class="col-md-4">
        <el-select class="select"
                   size="large"
                   placeholder="Project Type"
                   clearable
                   v-model="projectTypeFilter">
          <el-option v-for="option in projectTypes"
                     class="select"
                     :value="option.value"
                     :label="option.label"
                     :key="option.label">
          </el-option>
        </el-select>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <el-table class="wrap-whole-words"
                  :data="queriedData"
                  border
                  style="width: 100%; margin-top: 10px; margin-bottom: 20px">
          <el-table-column label="Tag">
            <template slot-scope="props">
              <span class="invisible">{{ props.row.id }}</span>
              <a href="#" @click.prevent="edit(props.row.id)">{{ props.row.name }}</a>
            </template>
          </el-table-column>
          <el-table-column prop="projectType" label="Project Type">
          </el-table-column>
          <el-table-column
            width="105"
            fixed="right"
            label="Actions">
            <template slot-scope="props">
              <p-button type="success" size="sm" icon>
                <i class="fa fa-edit" @click="edit(props.row.id)"></i>
              </p-button>
              <p-button type="danger" v-if="canEdit" size="sm" icon @click="confirmDelete(props.row)">
                <i class="fa fa-times"></i>
              </p-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>

<script>
  import {mapGetters} from 'vuex'
  import Constants from 'src/utilities/constants'
  import {notifySuccess, notifyError} from 'src/utilities/utils'
  import PButton from 'src/components/UIComponents/Button.vue'
  import Permissions from 'src/utilities/permissions'
  import {NO_CONTENT} from "http-status-codes"
  import { sync } from 'vuex-pathify'

  export default {
    components: {
      PButton
    },
    computed: {
      query: sync('inspectorApp/tags@query'),
      ...mapGetters({
        tableData: 'inspectorApp/tags/results',
        projectTypes: 'types/project'
      }),
      queriedData() {
        if (!this.searchQuery && !this.projectTypeFilter) {
          return this.tableData
        }
        return this.tableData.filter((row) => {
          const rowValue = row.name.toLowerCase()
          const query = this.searchQuery.trim().toLowerCase()
          if (this.searchQuery && this.projectTypeFilter) {
            return rowValue.includes(query) && this.projectTypeFilter === row.projectType
          } else if (this.searchQuery && !this.projectTypeFilter) {
            return rowValue.includes(query)
          } else if (!this.searchQuery && this.projectTypeFilter) {
            return this.projectTypeFilter === row.projectType
          }

          return false
        })
      },
      canRead() {
        return this.$can('read', Permissions.TAGS)
      },
      canEdit() {
        return this.$can('edit', Permissions.TAGS)
      }
    },
    data() {
      return {
        toDelete: null,
        projectTypeFilter: null,
        searchQuery: ''
      }
    },
    methods: {
      edit(id) {
        this.$eventHub.$emit('show-modal-1', 'Tag', {id: id}, '500px')
      },
      async updateInspectorAppTagResult() {
        await this.$store.dispatch('inspectorApp/tags/fetchAll')
      },
      async confirmDelete(inspectorAppTag) {
        this.toDelete = inspectorAppTag.id
        const showButton = true
        const message = 'Are you sure you want to delete this tag: <strong>' + inspectorAppTag.name + '</strong>, <strong>' + inspectorAppTag.projectType + '</strong>?'
        this.showConfirmDelete(inspectorAppTag, message, showButton)
      },
      showConfirmDelete(inspectorAppTag, message, showButton) {
        const payload = {
          message,
          entity: inspectorAppTag,
          delete: this.delete,
          showButton
        }
        this.$eventHub.$emit('show-modal-1', 'Confirm Delete', payload, '600px')
      },
      async delete() {
        const response = await this.$store.dispatch('delete', {
          endpoint: Constants.ENTITY_ENDPOINTS.TAGS,
          id: this.toDelete
        })
        if (NO_CONTENT === response.status) {
          this.$store.commit('inspectorApp/tags/delete', this.toDelete)
          notifySuccess(this, 'Inspector App Tag Deleted Successfully')
          return
        }
        notifyError(this, 'Error Deleting Inspector App Tag')
      }
    },
    async beforeMount() {
      this.$eventHub.$on('inspectorAppTagSaved', this.updateInspectorAppTagResult)
    },
    async mounted() {
      await this.$store.cache.dispatch('inspectorApp/tags/fetchAll')
    }
  }
</script>

<style>
</style>
